import { render, staticRenderFns } from "./JfpgManagement.vue?vue&type=template&id=36810842&"
import script from "./JfpgManagement.vue?vue&type=script&lang=js&"
export * from "./JfpgManagement.vue?vue&type=script&lang=js&"
import style0 from "./JfpgManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports